import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { ButtonGroup, SearchBox } from "@components";
import { TableColumn } from "./TableColumn";

import { TablePagination } from "@helpers/tablePagination";

import { STATUS } from "@constants/status.eTicket";

const { PENDING, ON_GOING, SOLVED, CLOSED } = STATUS;

export const RequestedTicketsTable = ({ data, ticketDropdown }: any) => {
  const [activeStatus, setActiveStatus] = useState(0);

  const { t } = useTranslation();
  const { control } = useForm();

  const { data: tickets, handleQuery, pagination } = data || {};
  const { size } = pagination || {};

  const filterButtons = t("TICKETS.TICKET_LIST.TABLE.ACTION_BUTTONS", {
    returnObjects: true,
  }) as string[];

  const btnGroupAction = (index: number) => {
    let statusId = null;
    setActiveStatus(index);

    switch (index) {
      case 0:
        statusId = null;
        break;
      case 1:
        statusId = PENDING;
        break;
      case 2:
        statusId = ON_GOING;
        break;
      case 3:
        statusId = SOLVED;
        break;
      case 4:
        statusId = CLOSED;
        break;
      default:
        statusId = null;
        break;
    }
    handleQuery("status", statusId);
  };

  return (
    <Table
      headerExtension={{
        leftComponents: [
          <ButtonGroup
            key="btn-group"
            btnGroupData={filterButtons}
            activeState={activeStatus}
            action={btnGroupAction}
          />,
        ],
        rightComponents: [
          <SearchBox
            key="search"
            placeholder={t("TICKETS.TICKET_LIST.TABLE.SEARCH")}
            control={control}
            handleQuery={handleQuery}
          />,
        ],
      }}
      columns={TableColumn(t, ticketDropdown)}
      rows={tickets}
      pagination={TablePagination(pagination, handleQuery)}
    />
  );
};
